import React, { useContext, useState } from 'react';
import { Field } from "formik";
import { GlobalAuthContext } from 'store/context';
import MasksHelper from 'utils/src/masks';
import Colors from "constants/Colors";
import { 
  Label, 
  CheckBox,
  Button,
  HasPermission,
  InputField
} from '@fitinsur/components';
import Icon from 'components/Icon';
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  SmallTitle,
  TableColumn,
  InlineLabel,
  TitleAlter,
  TableColumnCoverageItem,
  AddModalityContainer,
  AddButton,
  TextButton
} from './styles';
import './styles.css';

const MultipleRCGProductPlan = ({
  props: {
    calcList,
    history,
    idOperation,
    idProduct,
    formikValues,
    disabled,
    permissions,
    onRecalculate,
    handleCheckCoverage,
    onRecalculateItem,
    onConfirmPlanText,
    onConfirmPlan,
    disabledCommission,
    selectedOption,
    openHistoryModel,
    disabledConfirm,
    readOnlyMode,
    showHistory,
    showCoveragesAndExtensions,
    onOptionsDeductible,
    onSelectDeductible,
    hasCoverageCalc,
    showAlterButton,
    minCommission,
    maxCommission,
    handleAddOption,
    handleDeleteOptionOrModality,
    handleModalCoefficient,
    handleAddModality,
    handleEditModality
  },
  productPlanCoverage,
	option,
	showOption,
	parseNumber,
	currencyMask,
	expanded
}) => {
  const maskHelper = new MasksHelper();
	const authContext = useContext(GlobalAuthContext);
  const [coverageExpanded, setCoverageExpanded] = useState(true);
  const formikKey = readOnlyMode ? 'previousCalculationList' : 'calculationList';
  const letters = ['A','B','C'];

  const notCoverageProductPlan = (
		<TableColumnCoverageItem 
			colSpan={6} 
			width={20} 
			noBorder={expanded ? true : false} 
			rightBorder={expanded ? true : false}
		>
			<Icon name="not-ok"/>
		</TableColumnCoverageItem>
	);

	const coverageDisabledField = (style) => {
		return <Field
			style={style}
			name={'defaultValueCoverageDisabled'}
			component={InputField}
			type="text"
			validation={false}
			disabled={true}
			readOnly={true}
		/>
	}

  return (
    <TableComponent>
      <TableHead>
        <TableRow>
          <TableHeader className={'empty-th'} width={300} />
          {calcList.map((calculation, index) => {
            if (option != null && index != option) return <></>
            return (
              <TableHeader 
                colSpan={6} 
                style={{
                  textAlign: 'center',
                  color: Colors.WHITE,
                  borderTopRightRadius: 12,
                  borderTopLeftRadius: 12,
                }}
                backgroundColor={Colors.SECONDARY}
                onClick={(e) => {
                  if (selectedOption != null) return;
                  if (!permissions.NBI_REQUEST_APPROVE_REJECT) return;
                  e.stopPropagation();
                  showOption(index)
                }}
              >
                <span style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ flexGrow: 1, textAlign: 'center', marginLeft: '15px' }}>Opção {letters[index]}</span>
                  <HasPermission permission={!readOnlyMode}>
                    {(showHistory) ? <Icon 
                      name="icon-green_exclamation"
                      className={'icon-green_exclamation'}
                      style={{ textAlign: 'right', marginRight: '15px' }}
                      onClick={(e) => {
                        if (selectedOption != null) return;
                        e.stopPropagation();
                        openHistoryModel && openHistoryModel(index)
                      }} /> : <></>}
                    {calcList.length === index + 1 && index < 2 &&
                      <Icon
                        name="add-white"
                        style={{marginRight: '8px'}}
                        onClick={() =>  {
                          handleAddOption && handleAddOption()
                          expanded && showOption()
                        }}
                      />
                    }
                    {index > 0 &&
                      <Icon
                        name="garbage-white"
                        style={{marginRight: '8px'}}
                        onClick={() =>  {
                          handleDeleteOptionOrModality && handleDeleteOptionOrModality(calculation.idOperation, index)
                          expanded && showOption()
                        }}
                      />
                    }
                    <Icon 
                      name="icon-arrow-right-white"
                      className={expanded ? 'icon-arrow-left-white' : 'icon-arrow-right-white'}
                      style={{ textAlign: 'right', marginRight: '15px' }}
                    />
                  </HasPermission>
                </span>
              </TableHeader>
            )
          })}
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow backgroundColor={Colors.GRAY[4]}>
          <TableColumn style={{ borderTopLeftRadius: 12, borderTopRightRadius: 12 }} width={100}>
            <SmallTitle>
              Importância Segurada
              {!showAlterButton && <TitleAlter 
                onClick={() => { history.push(`/edit-enquiry/${idProduct}/${idOperation}`, { isEdit: true }) }}
              >
                Alterar
              </TitleAlter>}
            </SmallTitle>
          </TableColumn>
          {calcList.map((calculations, index) => {
            if (option != null && index != option) return <></>
            return (
              <TableColumn colSpan={6} center >
                <InlineLabel>
                  Opção {letters[index]}
                </InlineLabel>
                <Label weight={700}>
                  R$ {maskHelper.formatCurrency(authContext, calculations.coverageCalcList[0].coverageLimit)}
                </Label>
              </TableColumn>
            )
          })}
        </TableRow>
        
        <TableRow>
          <TableColumn width={100}>
            <SmallTitle>
              Prêmio Técnico Total
            </SmallTitle>
          </TableColumn>
          {calcList.map((calculations, index) => {
            if (option != null && index != option) return <></>
            return (
              <TableColumn colSpan={6} center>
                <InlineLabel>
                  Opção {letters[index]}
                </InlineLabel>
                <Label>
                  R$ {maskHelper.formatCurrency(authContext, parseNumber(calculations?.coverageAmountPremium || 0))}
                </Label>
              </TableColumn>
            )
          })}
        </TableRow>

        <TableRow>
          <TableColumn width={100}>
            <SmallTitle>
              Prêmio NET Total
            </SmallTitle>
          </TableColumn>
          {calcList.map((calculations, index) => {
            if (option != null && index != option) return <></>
            return (
              <TableColumn colSpan={6} center>
                <InlineLabel>
                  Opção {letters[index]}
                </InlineLabel>
                <Label>
                  R$ {maskHelper.formatCurrency(authContext, parseNumber(calculations?.coverageAmountDiscountLess || 0))}
                </Label>
              </TableColumn>
            )
          })}
        </TableRow>

        <TableRow>
          <TableColumn width={100}>
            <SmallTitle>
              Prêmio Líquido Total
            </SmallTitle>
          </TableColumn>
          {calcList.map((calculations, index) => {
            if (option != null && index != option) return <></>
            return (
              <TableColumn colSpan={6} center>
                <InlineLabel>
                  Opção {letters[index]}
                </InlineLabel>
                <Label>
                  R$ {maskHelper.formatCurrency(authContext, parseNumber(calculations?.coverageAmountTaxLess || 0))}
                </Label>
              </TableColumn>
            )
          })}
        </TableRow>

        <TableRow>
          <TableColumn width={100}>
            <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
              <SmallTitle>
                Coberturas
              </SmallTitle>
              <Icon 
                className={!coverageExpanded ? 'closed' : ''}
                name="arrow-up-primary-color"
                onClick={() => setCoverageExpanded(!coverageExpanded)}
              />
            </div>
          </TableColumn>
          {calcList.map((calculations, index) => {
            if (option != null && index != option) return <></>
            return <TableColumn colSpan={6} center />
          })}
        </TableRow>

        {coverageExpanded && productPlanCoverage.map(productPlan => {
          const planIndex = calcList[option]?.coverageCalcList?.findIndex(
            plan => plan.idProductPlan === productPlan.idProductPlan
          );

          if((
						planIndex === -1 || 
						planIndex === null ||
						planIndex === undefined
					) && expanded){
						return <></>
					}

          return <>
            <TableRow>
              <TableColumnCoverageItem width={100}>
                <SmallTitle>
                  {productPlan.productPlanName}
                  {expanded && option != null &&
                    <Icon
                      name='info'
                      style={{marginLeft: '8px', marginBottom: '-4px'}}
                      onClick={() => handleModalCoefficient && handleModalCoefficient(
                        planIndex,
                        productPlan.idProductPlan
                      )}
                    />
                  }
                </SmallTitle>
              </TableColumnCoverageItem>
              {showCoveragesAndExtensions && calcList.map((calculation, index) => {
                if (option != null && index != option) return <></>;
                return <>
                  <TableColumnCoverageItem 
                    className={'td-coverage'}
                    colSpan={index === option ? 1 : 6}
                    width={100} 
                    noBorder={expanded ? true : false}
                    rightBorder={expanded ? true : false}
                  >
                    <SmallTitle>
                      LMI
                    </SmallTitle>
                  </TableColumnCoverageItem>
                  <TableColumnCoverageItem 
                    className={'td-coverage'}
                    style={{ display: index === option ? 'table-cell' : 'none' }}
                    width={100}
                    noBorder={true}
                  >
                    <SmallTitle>
                      PR. TÉCNICO
                    </SmallTitle>
                  </TableColumnCoverageItem>
                  <TableColumnCoverageItem 
                    className={'td-coverage'}
                    style={{ display: index === option ? 'table-cell' : 'none' }}
                    width={50}
                    noBorder={true}
                  >
                    <SmallTitle>
                      %
                    </SmallTitle>
                  </TableColumnCoverageItem>
                  <TableColumnCoverageItem 
                    className={'td-coverage'}
                    style={{ display: index === option ? 'table-cell' : 'none' }}
                    width={100}
                    noBorder={true}
                  >
                    <SmallTitle>
                      PR. NET
                    </SmallTitle>
                  </TableColumnCoverageItem>
                  <TableColumnCoverageItem 
                    className={'td-coverage'}
                    style={{ display: index === option ? 'table-cell' : 'none' }}
                    width={100}
                    noBorder={true}
                  >
                    <SmallTitle>
                      PR. LÍQUIDO
                    </SmallTitle>
                  </TableColumnCoverageItem>
                  <TableColumnCoverageItem 
                    className={'td-coverage'}
                    style={{ display: index === option ? 'table-cell' : 'none' }}
                    width={140}
                    noBorder={true}
                  >
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                      <SmallTitle>
                        FRANQUIA
                      </SmallTitle>
                      {planIndex > 0 && 
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                          <Icon name='edit' onClick={() => handleEditModality && handleEditModality(
                            planIndex,
                            calculation?.coverageCalcList[planIndex]?.idOperation
                          )}/>
                          <Icon name='garbage' onClick={() => handleDeleteOptionOrModality && handleDeleteOptionOrModality(
                            calculation?.coverageCalcList[planIndex]?.idOperation
                          )}/>
                        </div>
                      }
                    </div>
                  </TableColumnCoverageItem>
                </>
              })}
            </TableRow>
            {productPlan.coverageItems.map((coverage, covIndex) => {
              return <TableRow>
                <TableColumnCoverageItem display={'flex'} style={{ textAlign: "left" }}>
                  {option != null && <Field
                    component={CheckBox}
                    name={`${formikKey}.${option}.coverageCalcList.${planIndex}.coverageItems.${covIndex}.coverageDisabled`}
                    checked={!coverage.coverageDisabled}
                    checkValue
                    disabled={readOnlyMode || !permissions.NBI_REQUEST_APPROVE_REJECT || disabled}
                    reverseValue
                    onChange={(value) => {
                      handleCheckCoverage && handleCheckCoverage(
                        value, 
                        option, 
                        coverage.idCoverage,
                        calcList[option].coverageCalcList[planIndex].idProductPlan,
                        calcList[option].coverageCalcList[planIndex].idOperation,
                        calcList[option].idOperation,
                      )
                    }} 
                  />}
                  <Label>{coverage.coverageName}</Label>
                </TableColumnCoverageItem>

							  {calcList.map((calculation, index) => {
                  if (option != null && index != option) return <></>
                  
                  const planIndex = calculation?.coverageCalcList.findIndex(
                    plan => plan.idProductPlan === productPlan.idProductPlan
                  );

                  const indexCoverage = calculation?.coverageCalcList[planIndex]?.coverageItems?.findIndex(
                    cov => cov.idCoverage === coverage.idCoverage
                  );
                  
                  const nameField = `${formikKey}.${index}.coverageCalcList.${planIndex}.coverageItems.${indexCoverage}`;
                  
                  const { 
                    coverageDisabled,
                    coefficientIS
                  } = formikValues?.calculationList[index].coverageCalcList[planIndex]?.coverageItems[indexCoverage] || {};

								  const coverageComponent = (<>
                    <TableColumnCoverageItem 
                      colSpan={index === option ? 1 : 6}
                      width={20}
                      noBorder={expanded ? true : false}
                      rightBorder={expanded ? true : false}
                    >
                      <InlineLabel>
                        LMI Opção {letters[index]}
                      </InlineLabel>
										{coverageDisabled ?
											coverageDisabledField({
												width: option != null ? '80%' : '180px',
												marginBottom: '0px',
												margin: "auto"
											}) : <>
                        <Field
                          style={{ width: option != null ? '80%' : '180px', marginBottom: '0px', margin: "auto" }}
                          mask={currencyMask()}
                          name={`${nameField}.coverageLimit`}
                          component={InputField}
                          type="text"
                          validation={false}
                          disabled={
                            readOnlyMode || 
                            !permissions.NBI_REQUEST_APPROVE_REJECT || 
                            disabled || 
                            coverageDisabled
                          }
                          readOnly={index === option ? false : true}
                          onBlur={(value) => index === option && onRecalculateItem && onRecalculateItem(
                            value,
                            index,
                            coverage.idCoverage,
                            'customCoverageLimit',
                            null,
                            calcList[option].coverageCalcList[planIndex].idProductPlan,
                            coverage.coverageDomain,
                            calcList[option].coverageCalcList[planIndex].idOperation,
                            calcList[option].idOperation
                          )}
                        />
                        {coefficientIS && 
                          <span style={{ fontSize: 12 }}>
                            Coeficiente IS: {coefficientIS}
                          </span>
                        }
                      </>
										}
									</TableColumnCoverageItem>
                  {index === option && <TableColumnCoverageItem width={20} noBorder={true}>
										<InlineLabel>
											PR. TÉCNICO Opção {letters[index]}
										</InlineLabel>
										{coverageDisabled ?
											coverageDisabledField({
												width: '80%',
												marginBottom: '0px',
												margin: "auto"
											}) :
											<Field
												style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
												name={`${nameField}.coveragePremium`}
												component={InputField}
												type="text"
												validation={false}
												mask={currencyMask()}
												disabled={
													readOnlyMode || 
													!permissions.NBI_REQUEST_APPROVE_REJECT || 
													disabled || 
													coverageDisabled
												}
												readOnly={true}
											/>
										}
									</TableColumnCoverageItem>}
									{index === option && <TableColumnCoverageItem width={20} noBorder={true}>
										<InlineLabel>
											% Opção {letters[index]}
										</InlineLabel>
										{coverageDisabled ?
											coverageDisabledField({
												width: '80%',
												marginBottom: '0px',
												margin: "auto"
											}) :
											<Field
												style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
												mask={maskHelper.getPercentage(authContext.region, 2, "1000", "-100", true)}
												name={`${nameField}.coveragePremiumDiscountRate`}
												component={InputField}
												type="text"
												validate={false}
												disabled={
													readOnlyMode || 
													!permissions.NBI_REQUEST_APPROVE_REJECT || 
													disabled || 
													coverageDisabled
												}
												onBlur={(value) => onRecalculateItem && onRecalculateItem(
													value / 100,
													index,
													coverage.idCoverage,
													'customCoveragePremiumDiscountRate',
													null,
                          calcList[option].coverageCalcList[planIndex].idProductPlan,
                          coverage.coverageDomain,
                          calcList[option].coverageCalcList[planIndex].idOperation,
                          calcList[option].idOperation
												)}
											/>
										}
									</TableColumnCoverageItem>}
									{index === option && <TableColumnCoverageItem width={20} noBorder={true}>
										<InlineLabel>
											PR. NET Opção {letters[index]}
										</InlineLabel>
										{coverageDisabled ?
											coverageDisabledField({
												width: '80%',
												marginBottom: '0px',
												margin: "auto"
											}) :
											<Field
												style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
												name={`${nameField}.coveragePremiumDiscountLess`}
												component={InputField}
												type="text"
												validation={false}
												mask={currencyMask()}
												disabled={
													readOnlyMode || 
													!permissions.NBI_REQUEST_APPROVE_REJECT || 
													disabled || 
													coverageDisabled
												}
												readOnly={true}
											/>
										}
									</TableColumnCoverageItem>}
									{index === option && <TableColumnCoverageItem width={20} noBorder={true}>
										<InlineLabel>
											PR. LÍQUIDO Opção {letters[index]}
										</InlineLabel>
										{coverageDisabled ?
											coverageDisabledField({
												width: '80%',
												marginBottom: '0px',
												margin: "auto"
											}) :
											<Field
												style={{ width: '80%', marginBottom: '0px', margin: "auto" }}
												mask={currencyMask()}
												name={`${nameField}.coveragePremiumTaxLess`}
												component={InputField}
												type="text"
												validation={false}
												disabled={
													readOnlyMode || 
													!permissions.NBI_REQUEST_APPROVE_REJECT || 
													disabled || 
													coverageDisabled
												}
												readOnly={true}
											/>
										}
									</TableColumnCoverageItem>}
									{index === option && <TableColumnCoverageItem width={20} noBorder={true}>
										<InlineLabel>
											FRANQUIA Opção {letters[index]}
										</InlineLabel>
										{coverageDisabled ?
											coverageDisabledField({
												width: '95%',
												margin: "0"
											}) :
											<Field
												style={{ width: '95%', margin: "0" }}
												name={`${nameField}.deductibleDescription`}
												component={InputField}
												type="text"
												validation={false}
												disabled={
													readOnlyMode || 
													!permissions.NBI_REQUEST_APPROVE_REJECT || 
													disabled || 
													coverageDisabled
												}
												onBlur={(value) => onRecalculateItem && onRecalculateItem(
													value,
													index,
													coverage.idCoverage,
													'customDeductibleDescription',
													null,
                          calcList[option].coverageCalcList[planIndex].idProductPlan,
                          coverage.coverageDomain,
                          calcList[option].coverageCalcList[planIndex].idOperation,
                          calcList[option].idOperation
												)}
											/>
										}
									</TableColumnCoverageItem>}
								</>)

								return indexCoverage === -1 || indexCoverage === null || indexCoverage === undefined ? 
                  notCoverageProductPlan : coverageComponent;
							})}
						</TableRow>
            })}
          </>
        })}

        {coverageExpanded && <TableRow>
					<TableColumn />
					{calcList.map((calculations, index) => {
						if (option != null && index != option) return <></>
						return <TableColumn colSpan={6} center/>
					})}
				</TableRow>}

        {expanded && option != null && calcList[option].coverageCalcList.length < 3 &&
          <TableRow>
            <TableColumn colSpan={7} noBorder>
              <div style={{ display: 'flex' }}>
                <AddModalityContainer onClick={() => handleAddModality && handleAddModality()}>
                  <TextButton>Adicionar uma nova Modalidade</TextButton>
                  <AddButton>+</AddButton>
                </AddModalityContainer>
              </div>
            </TableColumn>
          </TableRow>
        }

      </TableBody>
    </TableComponent>
  )
}

export default MultipleRCGProductPlan;